/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as OauthCallbackRouteImport } from './routes/oauth/callback'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthVerificationRouteImport } from './routes/_auth/verification'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthSignoutRouteImport } from './routes/_auth/signout'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthForgotRouteImport } from './routes/_auth/forgot'
import { Route as AuthAuthActionRouteImport } from './routes/_auth/auth-action'
import { Route as AppTradesRouteRouteImport } from './routes/_app/trades/route'
import { Route as AppThemePreviewRouteRouteImport } from './routes/_app/theme-preview/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppJournalRouteRouteImport } from './routes/_app/journal/route'
import { Route as AppInsightsRouteRouteImport } from './routes/_app/insights/route'
import { Route as AppImportRouteRouteImport } from './routes/_app/import/route'
import { Route as AppDashboardRouteRouteImport } from './routes/_app/dashboard/route'
import { Route as AppCalendarRouteRouteImport } from './routes/_app/calendar/route'
import { Route as AppAnalysisRouteRouteImport } from './routes/_app/analysis/route'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_auth.lazy').then((d) => d.Route))
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_app.lazy').then((d) => d.Route))
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerificationRoute = AuthVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignoutRoute = AuthSignoutRouteImport.update({
  id: '/signout',
  path: '/signout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthActionRoute = AuthAuthActionRouteImport.update({
  id: '/auth-action',
  path: '/auth-action',
  getParentRoute: () => AuthRoute,
} as any)
const AppTradesRouteRoute = AppTradesRouteRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => AppRoute,
} as any)
const AppThemePreviewRouteRoute = AppThemePreviewRouteRouteImport.update({
  id: '/theme-preview',
  path: '/theme-preview',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppJournalRouteRoute = AppJournalRouteRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRouteRoute = AppInsightsRouteRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppImportRouteRoute = AppImportRouteRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRouteRoute = AppDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRouteRoute = AppCalendarRouteRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisRouteRoute = AppAnalysisRouteRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/analysis': typeof AppAnalysisRouteRoute
  '/calendar': typeof AppCalendarRouteRoute
  '/dashboard': typeof AppDashboardRouteRoute
  '/import': typeof AppImportRouteRoute
  '/insights': typeof AppInsightsRouteRoute
  '/journal': typeof AppJournalRouteRoute
  '/settings': typeof AppSettingsRouteRoute
  '/theme-preview': typeof AppThemePreviewRouteRoute
  '/trades': typeof AppTradesRouteRoute
  '/auth-action': typeof AuthAuthActionRoute
  '/forgot': typeof AuthForgotRoute
  '/signin': typeof AuthSigninRoute
  '/signout': typeof AuthSignoutRoute
  '/signup': typeof AuthSignupRoute
  '/verification': typeof AuthVerificationRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesByTo {
  '/analysis': typeof AppAnalysisRouteRoute
  '/calendar': typeof AppCalendarRouteRoute
  '/dashboard': typeof AppDashboardRouteRoute
  '/import': typeof AppImportRouteRoute
  '/insights': typeof AppInsightsRouteRoute
  '/journal': typeof AppJournalRouteRoute
  '/settings': typeof AppSettingsRouteRoute
  '/theme-preview': typeof AppThemePreviewRouteRoute
  '/trades': typeof AppTradesRouteRoute
  '/auth-action': typeof AuthAuthActionRoute
  '/forgot': typeof AuthForgotRoute
  '/signin': typeof AuthSigninRoute
  '/signout': typeof AuthSignoutRoute
  '/signup': typeof AuthSignupRoute
  '/verification': typeof AuthVerificationRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/analysis': typeof AppAnalysisRouteRoute
  '/_app/calendar': typeof AppCalendarRouteRoute
  '/_app/dashboard': typeof AppDashboardRouteRoute
  '/_app/import': typeof AppImportRouteRoute
  '/_app/insights': typeof AppInsightsRouteRoute
  '/_app/journal': typeof AppJournalRouteRoute
  '/_app/settings': typeof AppSettingsRouteRoute
  '/_app/theme-preview': typeof AppThemePreviewRouteRoute
  '/_app/trades': typeof AppTradesRouteRoute
  '/_auth/auth-action': typeof AuthAuthActionRoute
  '/_auth/forgot': typeof AuthForgotRoute
  '/_auth/signin': typeof AuthSigninRoute
  '/_auth/signout': typeof AuthSignoutRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/verification': typeof AuthVerificationRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/_app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/analysis'
    | '/calendar'
    | '/dashboard'
    | '/import'
    | '/insights'
    | '/journal'
    | '/settings'
    | '/theme-preview'
    | '/trades'
    | '/auth-action'
    | '/forgot'
    | '/signin'
    | '/signout'
    | '/signup'
    | '/verification'
    | '/verify-email'
    | '/oauth/callback'
    | '/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/analysis'
    | '/calendar'
    | '/dashboard'
    | '/import'
    | '/insights'
    | '/journal'
    | '/settings'
    | '/theme-preview'
    | '/trades'
    | '/auth-action'
    | '/forgot'
    | '/signin'
    | '/signout'
    | '/signup'
    | '/verification'
    | '/verify-email'
    | '/oauth/callback'
    | '/'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/analysis'
    | '/_app/calendar'
    | '/_app/dashboard'
    | '/_app/import'
    | '/_app/insights'
    | '/_app/journal'
    | '/_app/settings'
    | '/_app/theme-preview'
    | '/_app/trades'
    | '/_auth/auth-action'
    | '/_auth/forgot'
    | '/_auth/signin'
    | '/_auth/signout'
    | '/_auth/signup'
    | '/_auth/verification'
    | '/_auth/verify-email'
    | '/oauth/callback'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OauthCallbackRoute: typeof OauthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verification': {
      id: '/_auth/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof AuthVerificationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signout': {
      id: '/_auth/signout'
      path: '/signout'
      fullPath: '/signout'
      preLoaderRoute: typeof AuthSignoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot': {
      id: '/_auth/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-action': {
      id: '/_auth/auth-action'
      path: '/auth-action'
      fullPath: '/auth-action'
      preLoaderRoute: typeof AuthAuthActionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/trades': {
      id: '/_app/trades'
      path: '/trades'
      fullPath: '/trades'
      preLoaderRoute: typeof AppTradesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/theme-preview': {
      id: '/_app/theme-preview'
      path: '/theme-preview'
      fullPath: '/theme-preview'
      preLoaderRoute: typeof AppThemePreviewRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journal': {
      id: '/_app/journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof AppJournalRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import': {
      id: '/_app/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AppImportRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis': {
      id: '/_app/analysis'
      path: '/analysis'
      fullPath: '/analysis'
      preLoaderRoute: typeof AppAnalysisRouteRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAnalysisRouteRoute: typeof AppAnalysisRouteRoute
  AppCalendarRouteRoute: typeof AppCalendarRouteRoute
  AppDashboardRouteRoute: typeof AppDashboardRouteRoute
  AppImportRouteRoute: typeof AppImportRouteRoute
  AppInsightsRouteRoute: typeof AppInsightsRouteRoute
  AppJournalRouteRoute: typeof AppJournalRouteRoute
  AppSettingsRouteRoute: typeof AppSettingsRouteRoute
  AppThemePreviewRouteRoute: typeof AppThemePreviewRouteRoute
  AppTradesRouteRoute: typeof AppTradesRouteRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalysisRouteRoute: AppAnalysisRouteRoute,
  AppCalendarRouteRoute: AppCalendarRouteRoute,
  AppDashboardRouteRoute: AppDashboardRouteRoute,
  AppImportRouteRoute: AppImportRouteRoute,
  AppInsightsRouteRoute: AppInsightsRouteRoute,
  AppJournalRouteRoute: AppJournalRouteRoute,
  AppSettingsRouteRoute: AppSettingsRouteRoute,
  AppThemePreviewRouteRoute: AppThemePreviewRouteRoute,
  AppTradesRouteRoute: AppTradesRouteRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAuthActionRoute: typeof AuthAuthActionRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignoutRoute: typeof AuthSignoutRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerificationRoute: typeof AuthVerificationRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthActionRoute: AuthAuthActionRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignoutRoute: AuthSignoutRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerificationRoute: AuthVerificationRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OauthCallbackRoute: OauthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
